// extracted by mini-css-extract-plugin
export var category = "_kx-9";
export var categoryHeader = "_kx-e";
export var container = "_kx-0";
export var group = "_kx-a";
export var groupItems = "_kx-f";
export var groupSeparator = "_kx-j";
export var loading = "_kx-1";
export var noResults = "_kx-3";
export var placeholder = "_kx-2";
export var resultContent = "_kx-5";
export var resultIcon = "_kx-c";
export var resultItem = "_kx-g";
export var resultMeta = "_kx-8";
export var resultSubtitle = "_kx-7";
export var resultSuffix = "_kx-i";
export var resultTitle = "_kx-6";
export var resultsList = "_kx-4";
export var searchGroup = "_kx-d";
export var selected = "_kx-h";
export var subgroup = "_kx-b";